import "@fontsource-variable/inter";
import "@fontsource-variable/newsreader";
import "lenis/dist/lenis.css";
import { StrictMode } from "react";
import { createRoot, hydrateRoot } from "react-dom/client";
import App from "./App";
import "./motion-lab.css";
import "./styles.css";
import "./theme.css";

// Public routes ship prerendered (scripts/prerender.mjs) so crawlers and first paint get real content; hydrate them.
// If the markup can't be matched (e.g. a remembered referral changes a line), React quietly re-renders on the client.
const root = document.getElementById("root")!;
const app = <StrictMode><App /></StrictMode>;
if (root.firstElementChild) hydrateRoot(root, app, { onRecoverableError: () => {} });
else createRoot(root).render(app);
